import { Link } from 'react-router-dom';

import { buttonVariants } from '../ui';
import { Center } from '@folio/components/ui/flex';
import { Text, Title } from '@folio/components/ui/text';

type ErrorViewTemplateProps = {
  title: string;
  code?: string;
  message: React.ReactNode;
  disableHomeButton?: boolean;
};

export const ErrorViewTemplate = ({
  title,
  message,
  code,
  disableHomeButton = false,
}: ErrorViewTemplateProps) => {
  return (
    <main className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        {code ? (
          <Text size="md" weight="semibold" tone="primary">
            {code}
          </Text>
        ) : null}
        <Title
          order={1}
          size="3xl"
          className="mt-4 tracking-tight text-gray-900 sm:text-5xl font-bold"
        >
          {title}
        </Title>
        <Text size="md" className="mt-6 leading-7 text-gray-600 text-center">
          {message}
        </Text>
        {!disableHomeButton && (
          <Center className="mt-10">
            <Link to="/" className={buttonVariants({ variant: 'secondary' })}>
              Retour à l&apos;accueil
            </Link>
          </Center>
        )}
      </div>
    </main>
  );
};
